<template>
  <div>
    <right-panel
      class="float-right"
      id="sidebar-edit-config"
      width="600px"
      :icon="'mdi mdi-plus'"
      :text="$t('common.edit')"
      @hidden="rightPanelClosed"
      @click="edit"
      :closeOnsave="true"
    >
      <div class="pl-5 pr-5">
        <Form :hide-library="true" />
      </div>
    </right-panel>
    <h2>Aktif Kulanıcılar</h2>
    <ol>
      <li v-for="account in loggedInAccounts" :key="account._id">
        <b> {{ account.name }}</b>
        <span class="muted ml-2">
          (
          <i> {{ account.email }} </i>
          )
        </span>
      </li>
    </ol>

    <div>
      <h2>{{ $t("config.text") }}</h2>
    </div>

    <div class="bg-white">
      <table class="table table-bordered table-striped">
        <!-- -- Contexts -->
        <thead class="bg-secondary text-white">
          <tr>
            <th>{{ $t("config.parameter") }}</th>
            <th>{{ $t("config.value") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>{{ $t("config.email-host") }}</td>
            <td>{{ config.emailHost }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.email-port") }}</td>
            <td>{{ config.emailPort }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.email-account") }}</td>
            <td>{{ config.emailAccount }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.email-pwd") }}</td>
            <td>{{ config.emailPwd }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.email-from") }}</td>
            <td>{{ config.emailFrom }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.email-tls-reject-unauthorized") }}</td>
            <td>{{ verbalize(config.emailTlsRejectUnauthorized) }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.recaptcha-key") }}</td>
            <td>{{ config.recaptchaKey }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.enable-recaptcha") }}</td>
            <td>{{ verbalize(config.enableRecaptcha) }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.cache-expire-time") }}</td>
            <td>{{ config.cacheExpireTime }}</td>
          </tr>

          <tr>
            <td>{{ $t("config.enable-multiple-auth") }}</td>
            <td>{{ verbalize(config.enableMultipleLogin) }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.enable-password-expiration") }}</td>
            <td>{{ verbalize(config.enablePasswordExpiration) }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.enable-last-three-distinct-password") }}</td>
            <td>{{ verbalize(config.enableLastThreeDistinctPassword) }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.enable-account-deactivation") }}</td>
            <td>{{ verbalize(config.enableAccountDeactivation) }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.account-deactivation-time") }}</td>
            <td>{{ config.accountDeactivationTime }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.translate-service") }}</td>
            <td>{{ config.translateService }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.translate-api-key") }}</td>
            <td>{{ config.translateApiKey }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.password-max-lifetime") }}</td>
            <td>{{ config.passwordMaxLifeTime }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.password-min-lifetime") }}</td>
            <td>{{ config.passwordMinLifeTime }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.enable-failed-login-attemps-deactivation") }}</td>
            <td>{{ verbalize(config.enableFailedLoginAttempsDeactivation) }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.max-failed-login-attemps") }}</td>
            <td>{{ config.maxFailedLoginAttemps }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.enable-white-label") }}</td>
            <td>{{ verbalize(config.enableWhiteLabel) }}</td>
          </tr>
          <tr>
            <td>{{ $t("config.uploaded-white-label") }}</td>
            <td>
              <div class="thumbnail" v-if="config.whiteLabel"><img :src="config.whiteLabel" alt="whiteLabel" width="24" /></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <content-loading v-if="loading" />
  </div>
</template>

<script>
import Form from "./management-config-parameter-form";

const state = "managementConfig";

export default {
  components: {
    Form,
  },
  data() {
    return {
      selectedItems: [],
    };
  },
  watch: {},
  computed: {
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    config() {
      return this.$store.getters[`${state}/config`];
    },
    loggedInAccounts() {
      return this.$store.getters[`${state}/loggedInAccounts`];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch(`${state}/list`);
      this.$store.dispatch(`${state}/loggedInAccounts`);
    },
    rightPanelClosed() {
      this.$store.commit(`${state}/editedEntity`, null);
      this.init();
    },
    verbalize(field) {
      return this.$t(field ? "common.yes" : "common.no");
    },

    edit() {
      this.$store.commit(`${state}/editedEntity`, { ...this.config });
    },
  },
};
</script>
